import { Buffer as BufferPolyfill } from 'buffer';

const base64Chars = new Uint8Array(128);
for (let code = 65; code <= 90; code++) {
  base64Chars[code] = 1;
}
for (let code = 97; code <= 122; code++) {
  base64Chars[code] = 1;
}
for (let code = 48; code <= 57; code++) {
  base64Chars[code] = 1;
}
base64Chars[43] = 1;
base64Chars[47] = 1;

const hasValidBase64Chars = (str) => {
  const paddingLength = str.endsWith('==') ? 2 : str.endsWith('=') ? 1 : 0;
  const contentLength = str.length - paddingLength;

  for (let index = 0; index < contentLength; index++) {
    const code = str.charCodeAt(index);
    if (code > 127 || base64Chars[code] !== 1) {
      return false;
    }
  }

  for (let index = contentLength; index < str.length; index++) {
    if (str[index] !== '=') {
      return false;
    }
  }

  return true;
};

const isBase64 = (input) => {
  if (typeof input !== 'string') {
    return false;
  }

  const str = input.trim();

  // data URI fast-path
  if (str.startsWith('data:')) {
    const commaIndex = str.indexOf(',');
    if (commaIndex > -1 && str.substring(0, commaIndex).toLowerCase().includes(';base64')) {
      return true;
    }
  }

  if (str.length < 8) {
    return false;
  }
  if (str.length % 4 !== 0) {
    return false;
  }

  if (!hasValidBase64Chars(str)) {
    return false;
  }

  try {
    const sampleLength = Math.min(str.length, 4096);
    const sliceLength = Math.floor(sampleLength / 4) * 4;
    if (sliceLength < 8) {
      return false;
    }
    const sample = str.slice(0, sliceLength);
    const reencoded = BufferPolyfill.from(sample, 'base64').toString('base64');
    return reencoded === sample;
  } catch (e) {
    return false;
  }
};

export default isBase64;
